module.exports = __webpack_public_path__ + "static/media/cross.004ff733.svg";